module.exports = __webpack_public_path__ + "img/gq.52b4ac09.svg";